import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { getShopifyStore } from '../helpers/urlTools';
import { Button, ButtonVariant, LoadingScreen, ErrorScreen, NotFoundScreen } from "@withfriendsco/wf-components";
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import { BUSINESS, CREATE_SHOPIFY_APP, GET_INSTALL_LINK, GET_INSTALL_LINK_BY_SHOPIFY_SHOP } from '../wf/queries';
const factor = 2500;
const holdMessages = [
    "...this can take a minute...",
    "...but that's because it's worth it...",
    `"Rome wasn't built in a day," they said...`,
    `"Rome ne fut pas faite toute en un jour," if we're really being meticulous...`,
    `...but trust us, it's worth waiting like, 20-30 seconds...`,
    `...because connecting your store is literally the most productive way to spend 20-30 seconds...`,
    `...your members will thank you...`,
    `...the crowds will cheer...`,
    `...they will lay garlands at your feet, replete with roses...`,
    `...but, most of all...`,
    `...approximately 5% of them will become members...`,
    `...which means your business will be more sustainable...`,
    `...more secure...`,
    `...more productive...`,
    `...more fulfilled...`,
    `...happier...`,
    `...this is what you've been waiting for...`,
    `...also, sorry it's taking so long...`,
    `...[hold music]...`,
    `...(email team@withfriends.co if you see this)...`
];
const ConnectShopify = ({ businessId }) => {
    var _a, _b, _c, _d, _e, _f;
    const [storeName, setStoreName] = useState("");
    const [errorText, setErrorText] = useState(_jsx("span", {}));
    const [isLoading, setIsLoading] = useState(false);
    const [confirmationLink, setConfirmationLink] = useState("");
    const [buttonText, setButtonText] = useState("Continue to connect your store");
    const [shopifyShop, setShopifyShop] = useState("");
    const [showDataPolicy, setShowDataPolicy] = useState(false);
    if (businessId) {
        var { loading, error, data } = useQuery(BUSINESS, {
            variables: { id: businessId },
        });
        var [getLink, { data: installData, stopPolling }] = useLazyQuery(GET_INSTALL_LINK, {
            variables: { id: businessId },
            pollInterval: 1000,
        });
        if (loading) {
            return _jsx(LoadingScreen, {});
        }
        if (error) {
            return _jsx(ErrorScreen, { message: error.message });
        }
        if (!(data === null || data === void 0 ? void 0 : data.business)) {
            return _jsx(NotFoundScreen, {});
        }
    }
    else {
        var [getLink, { data: installData, stopPolling }] = useLazyQuery(GET_INSTALL_LINK_BY_SHOPIFY_SHOP, {
            variables: { shopifyShop: shopifyShop },
            pollInterval: 1000,
        });
    }
    const [createShopifyApp] = useMutation(CREATE_SHOPIFY_APP);
    const handleStoreNameChange = (ev) => {
        setStoreName(ev.target.value);
    };
    const submitForm = async () => {
        var _a;
        setShowDataPolicy(false);
        setErrorText(_jsx("span", {}));
        let currentShopifyShop = getShopifyStore(storeName);
        setShopifyShop(currentShopifyShop);
        if (!currentShopifyShop) {
            setErrorText(_jsx("div", { className: "w-full border-salmon-600 p-2 my-4 border-2", children: _jsx("p", { className: "max-w-none prose lg:prose-lg", children: "Error! The robots couldn't read your URL. Please double-check that the URL of your online store ends with \"myshopify.com\"" }) }));
            return;
        }
        // mixpanel.track("Shopify Connect Submitted")
        setIsLoading(true);
        if (!businessId) {
            //@ts-ignore
            document.querySelector(".wf-button-continue").style.display = "none";
            //@ts-ignore
            document.querySelector(".wf-button-back").style.display = "none";
        }
        setButtonText("Connecting...");
        let loadTime = factor;
        for (const message of holdMessages) {
            setTimeout(() => {
                setButtonText(message);
                if (message == holdMessages[holdMessages.length - 1]) {
                    //@ts-ignore
                    document.querySelector(".wf-button-back").style.display = "inherit";
                }
            }, loadTime);
            loadTime += factor;
        }
        // Call the create
        await createShopifyApp({
            variables: Object.assign(Object.assign({}, businessId && {
                id: businessId,
                name: (_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.alias,
            }), {
                shopifyShop: currentShopifyShop,
            }),
        });
        getLink();
        return false;
    };
    if (stopPolling && (((_b = (_a = installData === null || installData === void 0 ? void 0 : installData.business) === null || _a === void 0 ? void 0 : _a.shopifyApp) === null || _b === void 0 ? void 0 : _b.installLink) || ((_c = installData === null || installData === void 0 ? void 0 : installData.shopifyApp) === null || _c === void 0 ? void 0 : _c.installLink)) && isLoading) {
        // mixpanel.track("Shopify Connect Robot Succeeded")
        stopPolling();
        let currentConfirmationLink = ((_e = (_d = installData === null || installData === void 0 ? void 0 : installData.business) === null || _d === void 0 ? void 0 : _d.shopifyApp) === null || _e === void 0 ? void 0 : _e.installLink) || ((_f = installData === null || installData === void 0 ? void 0 : installData.shopifyApp) === null || _f === void 0 ? void 0 : _f.installLink);
        setConfirmationLink(currentConfirmationLink);
        setIsLoading(false);
        setTimeout(stopPolling, 500);
        if (!businessId)
            window.top.location.href = currentConfirmationLink;
    }
    return (_jsx("div", { className: "text-center my-4 p-4 border border-gray-300", children: _jsxs(_Fragment, { children: [_jsx("h2", { className: "text-2xl font-bold mb-4", children: "Install our official Shopify app to continue" }), _jsx("p", { className: "mb-4", children: "Delight your customers with personalized subscription boxes and unlock recurring revenue, even without subscription-friendly products!" }), _jsx("a", { href: "https://apps.shopify.com/withfriends?utm_source=wf-onboarding", target: "_blank", rel: "noopener noreferrer", children: _jsx(Button, { className: "my-2", variant: ButtonVariant.Outlined, children: "Install Withfriends on Shopify" }) }), _jsx("p", { className: "mt-4", children: "How our Shopify app can help:" }), _jsxs("ul", { className: "list-disc list-inside text-left max-w-md mx-auto mt-2", children: [_jsx("li", { children: "Create AI-curated subscription boxes from your existing inventory" }), _jsx("li", { children: "Offer monthly, quarterly, or custom delivery schedules" }), _jsx("li", { children: "Let customers customize their boxes and gift subscriptions" }), _jsx("li", { children: "Integrate seamlessly with your fulfillment process" }), _jsx("li", { children: "Achieve a 14-month average subscriber lifetime" })] })] }) }));
};
export default ConnectShopify;
